import { useEffect, useState } from "react";
import { getBulkLabels } from "../api/requests";
import Spinner from "../components/Spinner";
import QueryParameters from "../api/QueryParameters";
import { UnsubsribeFormLabels } from "../labels/UnsubsribeFormLabels";
import { UnsubscribeFormLabelsMapper } from "../mappers/labels/UnsubscribeFormLabelsMapper";
import UnsubscribeButton from "../components/UnsubscribeButton";

type FormLoadingState = "Loading" | "Loaded";

export default function BulkUnsubscribe() {
  const [labels, setLabels] = useState<UnsubsribeFormLabels>({} as UnsubsribeFormLabels);
  const [loadingStatus, setLoadingStatus] = useState<FormLoadingState>("Loading");

  useEffect(() => {
    const queryParams = new QueryParameters();
    const mapper = new UnsubscribeFormLabelsMapper();
    getBulkLabels(queryParams).then((data) => {
      setLabels(mapper.get(data.labels));
      setLoadingStatus("Loaded");
    });
  }, []); //Leave array empty to load only once

  if (loadingStatus === "Loading") {
    return (
      <div className="center">
        <Spinner isLoading={true} />
      </div>
    );
  }
  return (
    <div className="bulk-unsubscribe">
      <h1>{labels.title.value}</h1>
      <div className="divider"></div>
      <p>{labels.subtitle.value}</p>
      <UnsubscribeButton
        buttonLabel={labels.button.value}
        thankYouLabel={labels.thankYou.value}
        errorMessage={labels.error.value}
        confirmButtonLabel={labels.confirmButtonLabel.value}
        confirmButtonUrl={labels.brandHomepageUrl.value}
      />
      <p
        className="bulk-unsubscribe-footer"
        dangerouslySetInnerHTML={{ __html: labels.footer.value }}
      />
    </div>
  );
}
